import React from 'react';
import IProps from './interface';
import { colors } from 'crono-fe-common/theme';

const ScriptsIcon = ({
  color = colors.grey1,
  size = 16,
  className,
}: IProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M10.5 8.99988H6.5"
      stroke={color}
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.5 5.99988H6.5"
      stroke={color}
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.1667 3.6665H6.5"
      stroke={color}
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.5 11.9999H14.125C14.8846 11.9999 15.5 11.3845 15.5 10.6249V2.37488C15.5 1.61523 14.8846 0.999878 14.125 0.999878H5.875C5.11535 0.999878 4.5 1.61523 4.5 2.37488V4.49988"
      stroke={color}
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.17791 11.322C4.54167 10.6858 4.06204 9.97348 3.74338 9.25082C3.67595 9.09802 3.71564 8.91912 3.83365 8.80112L4.27902 8.35632C4.64391 7.99146 4.64391 7.47543 4.32524 7.15678L3.68682 6.5184C3.26212 6.09372 2.57367 6.09372 2.14896 6.5184L1.79441 6.87293C1.39145 7.27586 1.22342 7.85715 1.33218 8.43354C1.60082 9.85439 2.4263 11.4101 3.75806 12.7418C5.08982 14.0735 6.64562 14.8989 8.06657 15.1675C8.64299 15.2763 9.22431 15.1082 9.62726 14.7053L9.98127 14.3513C10.406 13.9266 10.406 13.2382 9.98127 12.8136L9.3434 12.1757C9.02474 11.8571 8.50813 11.8571 8.19001 12.1757L7.69896 12.6673C7.58095 12.7853 7.40204 12.825 7.24924 12.7576C6.52653 12.4384 5.81416 11.9582 5.17791 11.322Z"
      stroke={color}
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default ScriptsIcon;
